import { render, staticRenderFns } from "./adminModels.vue?vue&type=template&id=60c13eda"
import script from "./adminModels.vue?vue&type=script&lang=js"
export * from "./adminModels.vue?vue&type=script&lang=js"
import style0 from "./adminModels.vue?vue&type=style&index=0&id=60c13eda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports